// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import _ from 'lodash';
import { Link } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';

// Services

// Components
import { Card } from 'components/content-containers/cards';
import { SVGButton } from 'components/widgets/buttons/buttons';
import CompanyLink from 'components/models/company/company-link';
import { MetadataTable, MetadataItem } from 'components/content-containers/tables';
import { GoogleDriveLink } from 'components/widgets/icons/link-icons';
import ShortDate from 'components/widgets/dates/short-date';
import BillableIcon from 'components/models/agreement/billable-icon';

// Utils
import { currency } from 'utils/format-utils';

// Constants
import { BILLING_ROLES } from 'constants';

// Component
function AgreementSummary({ agreement }) {
  const billable = agreement.timeDefaultBillable;
  const signedAgreements = _.orderBy(agreement.signedAgreements, ['createdAt'], ['asc']);

  return (
    <div className={classNames('agreement-summary', 'flex', 'flex-equal-children', `department-${_.kebabCase(agreement.department)}`)}>
      <div className="page-column">
        <Card className="agreement-details">
          <div className="card-header">{agreement.department}</div>
          <div className="summary-wrapper">
            <div className="card-icon-buttons">
              <Link to={`/admin/agreements/${agreement.id}/edit`}><SVGButton src="svg/edit.svg" className="edit-button edit-link" /></Link>
            </div>
            <MetadataTable>
              <MetadataItem label="Company"><CompanyLink company={agreement.company} /></MetadataItem>
              <MetadataItem label="Nickname">{agreement.nickname}</MetadataItem>
              <MetadataItem label="Duration">
                { agreement.endDate && <div><ShortDate date={agreement.startDate} /> - <ShortDate date={agreement.endDate} /></div> }
                { !agreement.endDate && <span>Ongoing (started <ShortDate date={agreement.startDate} />)</span> }
              </MetadataItem>
              <MetadataItem label="Billing">
                { agreement.monthly && <span>Monthly ({currency(agreement.monthlyRate)})<br />{agreement.monthlyDescription}</span> }
                { agreement.monthly && agreement.timeDefaultBillable && <br /> }
                { agreement.timeDefaultBillable && <span>Hourly</span> }
                { !agreement.monthly && !agreement.timeDefaultBillable && <span>Fixed</span> }
              </MetadataItem>
              <MetadataItem label="Rates">
                <div>
                  <BillableIcon billable={billable} />
                  <span> Time is { billable ? 'Billable' : 'Non-Billable' } by Default</span>
                </div>
                {_.map(BILLING_ROLES, role => {
                  const rate = _.find(agreement.rates, { role });

                  if (!rate) return <div key={role}>(unset) {role}</div>;

                  return <div key={rate.id}>{currency(rate.rate)} {rate.role}</div>;
                })}
              </MetadataItem>
              <MetadataItem label="After Hours">{currency(agreement.afterHoursPremium)}</MetadataItem>
              <MetadataItem label="Signed Agreement">
                {_.map(signedAgreements, signedAgreement =>
                  <div>
                    <GoogleDriveLink fileId={signedAgreement.fileId}>
                      <span className="margin-left">{signedAgreement.filename}</span>
                    </GoogleDriveLink>
                  </div>
                )}
              </MetadataItem>
            </MetadataTable>
          </div>
        </Card>
      </div>
      <div className="page-column" />
    </div>
  );
}

AgreementSummary.propTypes = {
  agreement: PropTypes.object
};

// Exports
export default connect((state) => ({
  agreement: state.agreements.agreement
}))(AgreementSummary);



// WEBPACK FOOTER //
// ./app/routes/agreement/sub-routes/agreement-summary.js